/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactMagnifier = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 4a7 7 0 0 0-4 12.745V14h8v2.745A7 7 0 0 0 11 4zm2 13.71V16H9v1.71c.634.189 1.305.29 2 .29s1.366-.101 2-.29zM2 11a9 9 0 1 1 16.05 5.596l3.66 3.7-1.42 1.407-3.65-3.689A9 9 0 0 1 2 11zm9-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgContactMagnifier as ContactMagnifier };
